import Backbone from '@trello/backbone';
import { TrelloStorage } from '@trello/storage';
import { clientVersion } from '@trello/config';
import {
  shouldReloadToUpdate,
  reloadedFromVersionStorageKey,
} from '@trello/client-updater';

export const navigate = (path, options) => {
  // If we're due for an update, refresh the page instead of routing client-
  // side.
  if (shouldReloadToUpdate(path)) {
    // Write the current version to local storage, so that we can pick it up on
    // the next page load and send an operational event
    try {
      TrelloStorage.set(reloadedFromVersionStorageKey, clientVersion);
    } catch (e) {
      // We can't do anything for storage write errors at this point, we're
      // about to reload anyhow
    }

    window.location = path;
    return;
  }

  Backbone.history.navigate(path, options);
};
